module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: ["dof-board"]
  }, [(_vm.title || _vm.subtitle) ? _c('div', {
    staticClass: ["dof-board-header"]
  }, [(_vm.title) ? _c('text', {
    staticClass: ["dof-board-header-title"]
  }, [_vm._v(_vm._s(_vm.title))]) : _vm._e(), (_vm.subtitle) ? _c('text', {
    staticClass: ["dof-board-header-subtitle"]
  }, [_vm._v(_vm._s(_vm.subtitle))]) : _vm._e()]) : _vm._e(), _vm._t("header"), _c('div', {
    style: _vm._boardBodyStyle
  }, [_vm._t("default")], 2)], 2)
},staticRenderFns: []}
module.exports.render._withStripped = true


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/template-compiler.js?id=data-v-6e4934c3!./~/weex-vue-loader/lib/selector.js?type=template&index=0!./packages/dof-board/index.vue
// module id = 628
// module chunks = 0 1